import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  Stack,
  Divider,
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import SecurityIcon from "@mui/icons-material/Security";
import SpeedIcon from "@mui/icons-material/Speed";
import DevicesIcon from "@mui/icons-material/Devices";
import VerifiedIcon from "@mui/icons-material/Verified";
import HubIcon from "@mui/icons-material/Hub";

export default function WebDevelopment() {
  return (
    <Box sx={{ backgroundColor: "#020617", color: "#e5e7eb" }}>
      {/* ================= HERO ================= */}
      <Box sx={{ py: 12 }}>
        <Container>
          <Typography
            variant="h3"
            align="center"
            fontWeight={600}
            gutterBottom
          >
            Web Application Development
          </Typography>

          <Typography
            align="center"
            sx={{ maxWidth: 900, mx: "auto", opacity: 0.9 }}
          >
            We build secure, scalable, and high-performance web applications
            designed to support rapid growth, seamless user experiences, and
            enterprise-grade reliability.
          </Typography>

          {/* Tabs */}
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            mt={6}
            flexWrap="wrap"
          >
            <Button sx={tab}>Modern Frameworks</Button>
            <Button sx={tab}>Enterprise Security</Button>
            <Button sx={tab}>High Performance</Button>
            <Button sx={tab}>Responsive Design</Button>
          </Stack>

          <Divider sx={{ mt: 3, borderColor: "#1e293b" }} />
        </Container>
      </Box>

      {/* ================= CORE SECTION ================= */}
      <Container sx={{ py: 10 }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h4" gutterBottom>
              Modern Web Solutions Built for Scale
            </Typography>

            <Typography sx={{ mb: 3, opacity: 0.9 }}>
              Our web applications are engineered using modern frameworks and
              architectures that prioritize performance, security, and
              maintainability.
            </Typography>

            <Typography sx={{ opacity: 0.85 }}>
              From enterprise dashboards to customer-facing platforms, we ensure
              reliability, flexibility, and long-term scalability.
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="https://images.unsplash.com/photo-1498050108023-c5249f4df085"
              alt="Web Development"
              sx={{
                width: "100%",
                borderRadius: 3,
                boxShadow: "0 20px 40px rgba(0,0,0,0.45)",
              }}
            />
          </Grid>
        </Grid>
      </Container>

      {/* ================= WHY CHOOSE US ================= */}
      <Box sx={{ backgroundColor: "#020617", py: 12 }}>
        <Container>
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            fontWeight={600}
          >
            Why Choose NerdsHub for Web Development?
          </Typography>

          <Grid container spacing={8} mt={4}>
            {/* Left Image */}
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d"
                alt="Web UX"
                sx={{ width: "100%", borderRadius: 3 }}
              />
            </Grid>

            {/* Right Content */}
            <Grid item xs={12} md={6}>
              <Feature
                icon={<LanguageIcon />}
                title="Modern Frameworks"
                desc="We leverage React, Next.js, and modern backend technologies to deliver fast, maintainable web applications."
              />

              <Feature
                icon={<DevicesIcon />}
                title="Responsive & Accessible"
                desc="Optimized for all devices and screen sizes with accessibility best practices built-in."
              />

              <Feature
                icon={<SpeedIcon />}
                title="Optimized Performance"
                desc="Fast load times, efficient rendering, and scalable architectures ensure superior user experiences."
              />
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* ================= SECURITY & DELIVERY ================= */}
      <Container sx={{ py: 12 }}>
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="https://images.unsplash.com/photo-1555949963-aa79dcee981c"
              alt="Web Security"
              sx={{ width: "100%", borderRadius: 3 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Feature
              icon={<SecurityIcon />}
              title="Enterprise-Grade Security"
              desc="Secure authentication, authorization, data protection, and compliance with industry standards."
            />

            <Feature
              icon={<HubIcon />}
              title="Scalable Architecture"
              desc="Built to scale seamlessly with modular design, cloud readiness, and API-first principles."
            />

            <Feature
              icon={<VerifiedIcon />}
              title="Reliable Delivery"
              desc="CI/CD pipelines, automated testing, and continuous monitoring ensure dependable releases."
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

/* ================= REUSABLE FEATURE ================= */

function Feature({ icon, title, desc }) {
  return (
    <Box sx={{ display: "flex", mb: 5 }}>
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: "50%",
          backgroundColor: "#ec4899",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mr: 3,
          color: "#fff",
        }}
      >
        {icon}
      </Box>

      <Box>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography sx={{ opacity: 0.85 }}>{desc}</Typography>
      </Box>
    </Box>
  );
}

/* ================= STYLES ================= */

const tab = {
  color: "#9ca3af",
  textTransform: "none",
};
